import * as React from "react";
import {
  Button,
  Card,
  Chip,
  Link,
  Stack,
  Typography,
} from "@mui/material";
import moment from "moment";
import { CustomDetailsList, CustomeDialog, Loader, usePermission } from "../../../shared";
import { OpeningAndClosingHourTable, StoreStatusManageModal } from "../../OnlineOrdering/components";

export const DoordashGenaralDetails = (props) => {

  const { state,
    handleInputChange,
    onUpdateWeekdays,
    handleManageModal,
    handleManageInput,
    onUpdateMangeStatus,
    handlePushMenu,
  } = props

  const {
    details,
    isBusy,
    manageModal,
    manageData,
  } = state

  const isEditable = usePermission("integration-modify");

  const column = [
    {
      title: "Door Dash Menu ID",
      accessor: "external_menu_id",
    },
    {
      title: "The last update was on",
      // accessor: "last_update_at",
      accessor: (row) => {
        return <Stack sx={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center"
        }}>
          <div>{row.last_update_at}</div>
          {row.connection_status === 1 && row.status === 1 ? (
            <div>
              {state.isSaveButton ? (
                <Stack
                  direction="row"
                  alignItems="center"
                  gap="4px"
                  className="uber-loader"
                >
                  <Loader />
                  <Typography
                    variant="subtitle2"
                    fontWeight={500}
                    color="#C07302"
                  >
                    Uploading...
                  </Typography>
                </Stack>
              ) : (
                <Stack
                  direction="row"
                  className="hover-icon-link"
                  gap={1}
                  sx={{ width: "fit-content" }}
                  alignSelf="end"
                  onClick={handlePushMenu}
                >

                  <img src="/icons/icon_blue_refresh.svg" />
                  <Link underline="none" component="button" variant="body2">
                    <Typography fontWeight={600}>Push Menu</Typography>
                  </Link>
                </Stack>)}
            </div>
          ) : ""}
        </Stack>;
      },
    },
  ]

  const column2 = [
    {
      title: "Holidays",
      accessor: (val) => {
        return (
          <Stack sx={{
            flexDirection: "row",
            gap: "8px",
          }}
          >
            {val.holidayList.map((v, i) => (
              <Chip
                key={i}
                label={v.holiday}
                variant="filled"
                size="small"
              />
            ))}
          </Stack>
        );
      },
    },
    {
      title: "Public Holidays",
      accessor: (val) => {
        return (
          <Stack sx={{
            flexDirection: "row",
            gap: "8px",
          }}
          >
            {isEditable && (
              <>
                {val.publicHolidayList.map((v, i) => (
                  <Chip
                    key={i}
                    label={v.holiday}
                    variant="filled"
                    size="small"
                  />
                ))}
              </>
            )}
          </Stack>
        );
      },
    },
  ]

  return (
    <>
      <Stack sx={{ mb: "24px" }}>
        <CustomDetailsList
          columns={column}
          data={details}
          title="Details"
        />
        <Card sx={{ mb: "24px" }}>
          <Stack
            sx={{
              flexDirection: "row",
              gap: "10px",
              justifyContent: "space-between",
              alignItems: "center",
              p: "24px"
            }}
          >
            <Stack gap="8px" >
              <Typography
                variant="body1"
                sx={{
                  fontWeight: 600,
                  lineHeight: "19px",
                }}
              >
                {details.external_manage_status === 1 ?
                  `The store is Open Today from ${moment(details.open_at, "HH:mm:ss").format("HH:mm")} to ${moment(details.close_at, "HH:mm:ss").format("HH:mm")}.`
                  : details.external_manage_status === 2 ? "The store will be closed Today." :
                    `The store is Closed Indefinitely`}

              </Typography>
            </Stack>
            {isEditable && (
              <Button
                variant="contained"
                onClick={() => handleManageModal(true)}
              >
                Manage
              </Button>
            )}
          </Stack>
        </Card>
        <OpeningAndClosingHourTable
          handleInputChange={handleInputChange}
          state={state}
          onUpdateWeekdays={onUpdateWeekdays}
        />
        <CustomDetailsList
          columns={column2}
          data={state.holidayData}
          title={
            <>
              <Typography
                variant="subtitle1"
                fontWeight={600}
                lineHeight="19px"
              >
                Holidays
              </Typography>
              <Typography
                variant="subtitle2"
                color="#636363"
              >
                These holidays have been configured by the store through the super admin panel.
              </Typography>
            </>
          }
        />

      </Stack>
      <CustomeDialog
        open={manageModal}
        PaperProps={{
          sx: { width: "423px", minHeight: "155px", p: "16px" },
        }}
        title="Manage"
        content={
          <StoreStatusManageModal
            details={details}
            data={manageData}
            handleManageModal={handleManageModal}
            onChange={handleManageInput}
            onUpdateMangeStatus={onUpdateMangeStatus}
          />
        }
      />
    </>
  );
};
